import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from 'app/shared/components/form-field/checkbox/checkbox.component';
import {MatCheckboxModule} from '@angular/material/checkbox';



@NgModule({
    declarations: [
        CheckboxComponent
    ],
    exports: [
        CheckboxComponent
    ],
    imports: [
        CommonModule,
        MatCheckboxModule
    ]
})
export class CheckboxModule { }
